<template>
    <div class="lottery-container">
        <div class="sub-container">
            <div class="lottery-header">
                <h1>LOTTERY</h1>
                <h2>{{ (data.type || '').toUpperCase() }} QUICK PICK RESULT</h2>
                <p>
                    <strong>{{ (data.type || '').toUpperCase() }} RESULT</strong> |
                    {{ formattedDate }} |
                    <strong>{{ formattedTime }}</strong>
                </p>
            </div>

            <div class="results">
                <div class="place">
                    <p class="place-label">First Place</p>
                    <div class="numbers">
                        <span v-for="(n, i) in digits(data.result)" :key="'d1-' + i">{{ n }}</span>
                    </div>
                </div>
                <div class="place">
                    <p class="place-label">Second Place</p>
                    <div class="numbers">
                        <span v-for="(n, i) in digits(data.result2)" :key="'d2-' + i">{{ n }}</span>
                    </div>
                </div>
                <div class="place">
                    <p class="place-label">Third Place</p>
                    <div class="numbers">
                        <span v-for="(n, i) in digits(data.result3)" :key="'d3-' + i">{{ n }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Countdown section omitted for brevity -->

        <div class="wrap-countdown">
    <div class="countdown-section" style="position: relative;">
        <h3>COUNTDOWN</h3>
        <div class="countdown" style="display: flex;justify-content: center;align-items: center">
            <template v-for="(digit, index) in countdownDigits" :key="index">
                <div class="wrap-white-font_digital">
                    <p class="bg-white-font_digital">{{ digit }}</p>
                </div>
                <!-- Add colon after HH and MM -->
                <div v-if="index === 1 || index === 3"
                    style="margin-left:5px;width: 15px;justify-content: center;display: flex;">
                    :
                </div>
            </template>
        </div>
        
        <!-- Teks berbeda untuk setiap tipe -->
        <p style="font-size: 10px;">
            <template v-if="data.type === '3d'">
                Results every 45 minutes (32x results a day)
            </template>
            <template v-else-if="data.type === '4d'">
                Result Every 8 Hours (3x Result a day)            
            </template>
            <template v-else-if="data.type === '5d'">
                Result Everyday (1x Result a day)
            </template>
        </p>
        
        <router-link :to="`/${data.type || '3d'}_result`" class="results-link text-decoration-none">
            See All Results
        </router-link>

        <br><br>
        <div class="countdown-line" style="height: 4px;position: absolute;width: 100%;"></div>
    </div>
</div>

        <!-- <div class="wrap-countdown">
            <div class="countdown-section" style="position: relative;">
                <h3>COUNTDOWN</h3>
                <div class="countdown" style="display: flex;justify-content: center;align-items: center">
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                    <div style="margin-left:5px;width: 15px;justify-content: center;display: flex;">:</div>
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                    <div style="margin-left:5px;width: 15px;justify-content: center;display: flex;">:</div>
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                    <div class="wrap-white-font_digital">
                        <p class="bg-white-font_digital">0</p>
                    </div>
                </div>
                <p style="font-size: 10px;">Results every 45 minutes (32x results a day)</p>
                <a href="#" class="results-link text-decoration-none">See All Results</a>
                <br><br>
                <div class="countdown-line" style="height: 4px;position: absolute;width: 100%;">
                </div>
            </div>
        </div> -->

    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            countdown: '00:00:00'
        };
    },
    computed: {
        formattedDate() {
            const raw = this.data.datetime;
            if (!raw) return '—';
            const date = new Date(raw);
            return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
        },
        formattedTime() {
            const raw = this.data.datetime;
            if (!raw) return '—';
            const date = new Date(raw);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },
        countdownDigits() {
            return this.countdown.replace(/:/g, '').split('');
        }
    },
    mounted() {
        this.startCountdown();
    },
    methods: {
        digits(value) {
            return String(value ?? '').split('');
        },
        startCountdown() {
            const update = () => {
                const now = new Date();
                const end = new Date(this.data.nextDrawTime);
                const diff = Math.max(0, end - now);

                const hours = Math.floor(diff / (1000 * 60 * 60)).toString().padStart(2, '0');
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                const seconds = Math.floor((diff % (1000 * 60)) / 1000).toString().padStart(2, '0');

                this.countdown = `${hours}:${minutes}:${seconds}`;
            };

            update();
            setInterval(update, 1000);
        }
    }
};
</script>

<style scoped>
.lottery-container {
    margin-right: 20px;
    font-family: sans-serif;
    background: #fff;
    border-radius: 16px;
    max-width: 100%;
    margin: auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.sub-container {
    padding: 20px;
    border-bottom: 4px solid #FFCD05;
}

.countdown-line {
    border-top: 10px solid #FFCD05;
    border-radius: 5px;
}

.lottery-header {
    text-align: center;
}

.lottery-header h1 {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
    padding: 0;
    color: #707070;
}

.lottery-header h2 {
    color: #2e3d96;
    margin: 0;
    font-weight: bold;
    margin-bottom: 8px;
    padding: 0;
    font-size: 18px;
}

.lottery-header p {
    font-size: 14px;
}

.results {
    margin: 20px 0;
    text-align: center;
}

.place {
    margin: 10px 0;
}

.place-label {
    font-style: italic;
    margin-bottom: 5px;
}

.numbers {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.numbers span {
    background: #2e3d96 !important;
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
}

.countdown-section {
    color: white;

    margin: 0px 50px;
    text-align: center;
    border-radius: 2px;
    /* border-bottom: 4px solid #FFCD05; */
}

.wrap-countdown {
    background: #2e3d96;
    padding: 20px 20px 4px 20px;
}


.countdown {
    font-size: 28px;
    letter-spacing: 4px;
    font-weight: bold;
    margin: 10px 0;
}

.results-link {
    color: white;
    text-decoration: underline;
    font-weight: bold;
}
</style>